import { useRef, useState } from 'react';
import { Container, Text } from '@weareconceptstudio/core';

//* Styles
import HeroHomeStyle from './style';

//* Component
import Button from '@/components/Button';
import TitleAnim from '@/modules/_animation/Title';
import FileSection from '@/components/FileSection';
import StyledQuotedText from '@/components/StyledQuotedText';
import { config } from '@/helpers';

const HeroHome = ({ description, desktop_image, mobile_image, title }) => {
	//! Ref
	const titleRef = useRef();

	//! State
	const [loadPicture, setLoadPicture] = useState(false);

	return (
		<HeroHomeStyle className={`${loadPicture ? 'active' : ''}`}>
			<div className='wrapper-picture'>
				<FileSection
					isIcon={false}
					muted={true}
					autoPlay={true}
					videoLoop={true}
					onLoad={setLoadPicture}
					double={[desktop_image, mobile_image].filter(Boolean)}
				/>
			</div>
			<div className='info-wrapper'>
				<Container row>
					<div className='empty col-3 col-dx-1' />
					<div className='col-6 col-dx-10 col-m-12'>
						<div className='info-content '>
							<div className='title-wrap'>
								<TitleAnim load={loadPicture}>
									<StyledQuotedText text={title} />
								</TitleAnim>
							</div>

							<Text className={'description p1 font-fss-light white-1000'}>{description}</Text>
							<div className='wrap-button'>
								<Button
									url={config.routes.products.path}
									btnType={'yellow-type'}
									text={'ourProducts'}
								/>
							</div>
						</div>
					</div>

					<div className='empty col-3 col-dx-1' />
				</Container>
			</div>
		</HeroHomeStyle>
	);
};

export default HeroHome;
